import Vue from 'vue'
import locale from 'element-ui/lib/locale'   // Element UI 的内部多语言处理钩子（用来让 Element UI 跟着切换语言）。
import VueI18n from 'vue-i18n'
import en from './langs/en'
import cn from './langs/cn'
import Cookies from 'js-cookie'

Vue.use(VueI18n)

// 检查浏览器是否能用 Cookie
// 它会写一个临时 cookie _cookie_test，然后读取，最后删除。
// 如果能读到正确值，说明浏览器支持 cookie（有些隐私模式或禁用了 cookie 的浏览器可能会失败）。
function canUseCookies() {
  try {
    Cookies.set('_cookie_test', '1')
    const value = Cookies.get('_cookie_test')
    Cookies.remove('_cookie_test')
    return value === '1'
  } catch (e) { // ✅ 加上参数
    return false;
  }
}

// 优先使用 navigator.languages[0]（多语言列表的第一个）。
// 如果检测到字符串以 zh 开头（zh, zh-cn, zh-tw 等），就返回 'cn'，否则返回 'en'。
function getBrowserLanguage() {
  const browserLang = (
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.browserLanguage ||
    navigator.systemLanguage ||
    navigator.userLanguage ||
    ''
  ).toLowerCase()

  console.log('当前浏览去语言环境:',  browserLang)

  return /^zh\b/.test(browserLang) ? 'cn' : 'en'
}

console.log('当前浏览去语言环境:',  getBrowserLanguage())
// 安全读取 Cookie,避免浏览器禁用 cookie 时直接报错。
function getSafeCookie(name) {
  try {
    return Cookies.get(name)
  } catch (e) { // ✅ 加上参数
    return null
  }
};



//Cookie 里有 globalLanguage → 用它
// 没有 Cookie → 用浏览器语言（getBrowserLanguage()）
// 两者都没有 → 默认 'cn'
const messages = {en, cn}
const preferredLanguage = getSafeCookie('globalLanguage') || getBrowserLanguage() || 'cn'
// console.log('preferredLanguage:', preferredLanguage)
// console.log('getSafeCookie:', getSafeCookie('globalLanguage'))
// 首次访问时写入 Cookie
// 如果还没有 globalLanguage 这个 cookie，而且浏览器支持 cookie
if (!getSafeCookie('globalLanguage') && canUseCookies()) {
  Cookies.set('globalLanguage', preferredLanguage)
}

//locale: 当前语言（刚刚计算出来的 preferredLanguage）。
// fallbackLocale: 兜底语言（翻译缺失时用英文）。
// messages: 语言包 { en, cn }。
const i18n = new VueI18n({
  locale: preferredLanguage,
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true
})

// 把 Element UI 的语言获取函数绑定到 i18n.t 上，这样 Element UI 里的文案也能跟随切换。
try {
  locale.i18n((key, value) => i18n.t(key, value))
} catch (e) {
  console.error('Element UI多语言初始化失败:', e)
}

export default i18n


//默认语言规则（优先级从高到低）：
// 如果 cookie 里有 globalLanguage → 用 cookie 里的值。
// 否则，如果浏览器语言是 zh 系列（zh-cn, zh-tw 等） → 默认中文（cn）。
// 否则 → 默认英文（en）。
// 如果浏览器语言都检测不到（极少数情况） → 默认中文（cn）。



// WEBPACK FOOTER //
// ./src/i18n/i18n.js